<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      ref="main"
      @editClosed="editClosed"
    >
      <page-header ref="header" slot="header" :disabled="disabled" />
    </page-main>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageHeader,
    PageMain,
  },
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      // todo:这个功能的代码，是不是废代码，如果是废代码需要删除掉，避免歧义
      this.loading = true
      this.$api
        .shipmentBookingContainerPoListApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    validate() {
      return this.$refs.main.validate()
    },
    editClosed(e) {
      this.$emit('editClosed', e)
    },
    updateBookingNo(e) {
      this.tableData.forEach((item) => {
        item.bookingNo = e
      })
    },
    updateCustomsNo(e) {
      this.tableData.forEach((item) => {
        item.customsNo = e
      })
    },
  },
}
</script>
